/**
 * src/components/Footer.jsx
 */
export function Footer() {
  return (
    <footer className="footer">
      <div style={{ fontWeight: 700, fontSize: 20, marginBottom: 6 }}>Ritu Fashion Store</div>
      <div style={{ color: "#9ca3af", fontSize: 14, marginBottom: 16 }}>
        Since 1996 • Premium Kids Fashion in Gurgaon
      </div>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 16, fontSize: 14, color: "#d1d5db", flexWrap: "wrap" }}>
        <span>+91 98735 64717</span>
        <span>•</span>
        <a href="https://wa.me/919873804717" target="_blank" rel="noopener noreferrer" style={{ color: "#d1d5db" }}>
          💬 WhatsApp
        </a>
      </div>
      <div style={{ marginTop: 20, fontSize: 13, color: "#6b7280" }}>© 2026 Ritu Fashion Store. All rights reserved.</div>
    </footer>
  );
}